import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import authenticate from "./system/auth/authenticate";

Vue.use(Router);

// create new router

export const routes = [
  {
    path: "/manage/",
    component: () => import("./views"), //webpackChunkName app
    beforeEnter: authenticate,
    redirect: "/manage/dashboard/dashboard",

    children: [
      {
        path: "/manage/dashboard",
        component: () => import("./views/dashboard"),
        meta: { permission: '1' },
        children: [
          {
            path: "dashboard",
            component: () => import("./views/dashboard/dashboard"),
            meta: { permission: '11', always: true },
          },
        ]
      },
      {
        path: "/manage/staff",
        component: () => import("./views/staff"),
        meta: { permission: '2' },
        children: [
          {
            path: "staffList",
            component: () => import("./views/staff/staffList"),
            meta: { permission: '21' },
          },
        ]
      },
      {
        path: "/manage/shareholder",
        component: () => import("./views/shareholder"),
        meta: { permission: '3' },
        children: [
          {
            path: "shareholderList",
            component: () => import("./views/shareholder/shareholderList"),
            meta: { permission: '31' },
          },
        ]
      },
      {
        path: "/manage/shop",
        component: () => import("./views/shop"),
        meta: { permission: '4' },
        children: [
          {
            path: "shopList",
            component: () => import("./views/shop/shopList"),
            meta: { permission: '41' },
          },
          {
            path: "shopDetail",
            component: () => import("./views/shop/shopDetail"),
            meta: { permission: '41' },
            hidden: true,
          },
          {
            path: "shopTransaction",
            redirect: (to) => ({
              path: "/manage/shop/shopDetail",
              query: { ...to.query, tab: "transaction" },
            }),
          },
        ]
      },
      {
        path: "/manage/transactionType",
        component: () => import("./views/transactionType"),
        meta: { permission: '5' },
        children: [
          {
            path: "transactionTypeList",
            component: () => import("./views/transactionType/transactionTypeList"),
            meta: { permission: '51' },
          },
        ]
      },
      {
        path: "/manage/record",
        component: () => import("./views/record"),
        meta: { permission: '6' },
        children: [
          {
            path: "activityLog",
            component: () => import("./views/record/activityLog"),
            meta: { permission: '61', always: true },
          },
        ]
      },
    ]
  },
  // sessions
  {
    path: "/manage/sessions",
    component: () => import("./views/sessions"),
    redirect: "/manage/sessions/signIn",
    children: [
      {
        path: "signIn",
        component: () => import("./views/sessions/signIn")
      },
    ]
  },

  {
    path: "/",
    component: () => import("./views/sessions/download"),
  },

  {
    path: "*",
    component: () => import("./views/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  // to, from, savedPosition
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path) {
    // Start the route progress bar.

    NProgress.start();
    NProgress.set(0.1);
  }
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  // Complete the animation of the route progress bar.
  setTimeout(() => NProgress.done(), 500);
  // NProgress.done();
});

export default router;
